import React from "react";
import {
  Box,
  Typography,
  Container
} from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";

export default function EndExam() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            bgcolor: "#fff",
            color: "#000",
            p: 3,
            pb: 6,
            textAlign: "center",
            border: "1px solid black",
            borderRadius: "12px",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 60, mb: 2, color: "green" }} />
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            Exam is over
          </Typography>
          {/* <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Congratulations! Your exam has been submitted successfully. You will
            receive further instructions and results shortly.
          </Typography> */}
        </Box>
      </Container>
    </Box>
  );
}